import strings from 'strings';

export const DEBRIEF_PARTICIPANT = {
  Employer: 'employer',
  Candidate: 'candidate'
};

export const DEBRIEF_TITLE_BY_PARTICIPANT = {
  [DEBRIEF_PARTICIPANT.Employer]: strings.sendoutsV2.drawers.interviewDebrief.employer.title,
  [DEBRIEF_PARTICIPANT.Candidate]: strings.sendoutsV2.drawers.interviewDebrief.candidate.title
};
